import { observer } from 'mobx-react';
import React from 'react';
import { Menu, contextMenu } from 'react-contexify';
import useActiveThemeVariation from '../../../../themes/hooks/UseActiveThemeVariation';
import StackLayout from '../../../layouts/stackLayout/StackLayoutComponent';
import ContextMenuContext from '../dataLayer/contexts/ContextMenuContext';
import useContextMenuStore from '../dataLayer/hooks/UseContextMenuStore';
import 'react-contexify/dist/ReactContexify.css';
import './ContextMenu.css';
var ContextMenuImplementation = function (props) {
    var contextMenuKey = props.contextMenuKey, children = props.children;
    var contextMenuStore = useContextMenuStore();
    var activeVariation = useActiveThemeVariation(props, function (x) { return x.advancedControlsThemes.contextMenu; });
    return (React.createElement(Menu, { id: contextMenuKey, onHidden: function () {
            contextMenuStore.closeContextMenu();
        }, animation: "scale" },
        React.createElement(ContextMenuContext.Provider, { value: activeVariation },
            React.createElement(StackLayout, { id: "contextMenu_" + contextMenuKey, testId: "contextMenu_" + contextMenuKey, backgroundColor: activeVariation.backgroundColor, border: activeVariation.border, borderColor: activeVariation.borderColor, borderRadius: activeVariation.borderRadius }, children))));
};
export default observer(ContextMenuImplementation);
/**
 * It could be, that the context menu is out of screen
 * This function moves it again in the screen
 */
function ensureThatContextMenuIsInsideScreen(contextMenuKey) {
    var _a;
    var contextMenuElement = (_a = window.document.getElementById("contextMenu_" + contextMenuKey)) === null || _a === void 0 ? void 0 : _a.parentElement;
    if (!contextMenuElement) {
        return;
    }
    var rightContextMenuPosition = contextMenuElement.getClientRects()[0].left + contextMenuElement.offsetWidth;
    if (window.innerWidth > rightContextMenuPosition) {
        return;
    }
    // we need a small delay, to ensure that the left property was updated
    setTimeout(function () {
        contextMenuElement.style.left = window.innerWidth - contextMenuElement.offsetWidth + "px";
    }, 50);
}
export function handleTriggerEvent(triggerEvent, key) {
    triggerEvent.preventDefault();
    triggerEvent.stopPropagation();
    triggerEvent.persist();
    contextMenu.show({
        id: key,
        event: triggerEvent
    });
    ensureThatContextMenuIsInsideScreen(key);
}
//# sourceMappingURL=ContextMenuImplementation.js.map